import { z } from 'zod';

/* =====================================================================
   Schemas de los 4 juegos — espejo de los JSON actuales (Fase 1).
===================================================================== */

export const categorySchema = z.enum(['GenAI', 'Cloud', 'Analytics', 'eTribe']);
export type Category = z.infer<typeof categorySchema>;

export const questionSchema = z.object({
  cat: categorySchema,
  q: z.string().min(1),
  a: z.tuple([z.string(), z.string(), z.string(), z.string()]),
  c: z.union([z.literal(0), z.literal(1), z.literal(2), z.literal(3)]),
  d: z.union([z.literal(1), z.literal(2), z.literal(3)]),
  _validated: z.string().optional(),
});
export type Question = z.infer<typeof questionSchema>;

export const techOptionSchema = z.object({
  n: z.string().min(1),
  i: z.string().min(1),
});
export type TechOption = z.infer<typeof techOptionSchema>;

export const scenarioSchema = z.object({
  snum: z.number().int().positive(),
  title: z.string().min(1),
  desc: z.string().min(1),
  industry: z.string().min(1),
  correct: z.array(z.string().min(1)).min(1),
  all: z.array(techOptionSchema).min(1),
});
export type Scenario = z.infer<typeof scenarioSchema>;

export const caseSchema = z.object({
  id: z.number().optional(),
  title: z.string().min(1),
  clues: z.array(z.string().min(1)).min(1),
  opts: z.array(z.string().min(1)).min(2),
});
export type Case = z.infer<typeof caseSchema>;

export const pokemonTypeSchema = z.enum(['pokemon', 'bigdata']);
export type PokemonType = z.infer<typeof pokemonTypeSchema>;

export const pokemonItemSchema = z.object({
  name: z.string().min(1),
  type: pokemonTypeSchema,
  pokemonId: z.number().int().positive().optional(),
  description: z.string().min(1),
  emoji: z.string().optional(),
  _validated: z.string().optional(),
});
export type PokemonItem = z.infer<typeof pokemonItemSchema>;

/* =====================================================================
   Collections — un mapa { id: item } por colección, leído de RTDB.
   El id viene del key del nodo (push-id o slug). Aceptamos null porque
   onValue devuelve null cuando el nodo está vacío.
===================================================================== */

const collection = <T extends z.ZodTypeAny>(item: T) =>
  z.record(z.string(), item).nullable().transform((v) => v ?? {});

export const questionsMapSchema = collection(questionSchema);
export const scenariosMapSchema = collection(scenarioSchema);
export const casesMapSchema = collection(caseSchema);
export const pokemonMapSchema = collection(pokemonItemSchema);

export type QuestionsMap = z.infer<typeof questionsMapSchema>;
export type ScenariosMap = z.infer<typeof scenariosMapSchema>;
export type CasesMap = z.infer<typeof casesMapSchema>;
export type PokemonMap = z.infer<typeof pokemonMapSchema>;
